import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

const I = (name, size, extra) => h(Icon, { name, size, ...(extra || {}) });

/**
 * @param {object} p
 * @param {number} p.page
 * @param {number} [p.pageSize]
 * @param {number} p.total
 * @param {(page: number) => void} p.onPage
 */
export function Pagination({ page = 1, pageSize = 50, total = 0, onPage }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total ? (page - 1) * pageSize + 1 : 0, to = Math.min(total, page * pageSize);
  const nums = []; for (let p = Math.max(1, page - 2); p <= Math.min(pages, page + 2); p++) nums.push(p);
  const btn = (p, label, icon, dis) => h('button', { key: label, type: 'button', disabled: dis, onClick: () => onPage && onPage(p), 'aria-label': icon ? label : 'Page ' + p, 'aria-current': !icon && p === page ? 'page' : undefined,
    style: { display: 'grid', placeItems: 'center', minWidth: 30, height: 30, padding: '0 6px', border: !icon && p === page ? ink(2) : '2px solid transparent', borderRadius: 8, background: !icon && p === page ? 'var(--gold)' : 'transparent', color: !icon && p === page ? 'var(--on-accent)' : 'var(--tx)', fontFamily: BODY, fontSize: 12.5, fontWeight: 800, cursor: dis ? 'default' : 'pointer', opacity: dis ? .35 : 1, fontVariantNumeric: 'tabular-nums' } }, icon ? I(icon, 16) : p);
  return h('nav', { 'aria-label': 'Pagination', style: { display: 'flex', alignItems: 'center', gap: 4, fontFamily: BODY } },
    h('span', { style: { fontSize: 12, fontWeight: 600, color: 'var(--mut2)', marginRight: 'auto', fontVariantNumeric: 'tabular-nums' } }, total ? `${from.toLocaleString('en-US')}–${to.toLocaleString('en-US')} of ${total.toLocaleString('en-US')}` : 'No results'),
    btn(page - 1, 'Previous page', 'chevron-left', page <= 1), nums.map((p) => btn(p, String(p))), btn(page + 1, 'Next page', 'chevron-right', page >= pages));
}
